// Pure reducer for the single polite aria-live region owned by ExperienceProvider
// (arch doc §4.8/D18). Navigation/orientation announcements take precedence over
// celebration announcements. On a same-tick conflict the celebration is DROPPED
// (not queued) so it can never clobber a route-change announcement.
export function reduceAnnouncement(state, action) {
  const prev = state || null;
  if (!action || !action.text) return prev;

  if (action.kind === 'navigation') {
    return { kind: 'navigation', text: action.text, tick: ((prev && prev.tick) || 0) + 1 };
  }

  // celebration
  if (action.sameTick && prev && prev.kind === 'navigation') {
    return prev; // dropped: a celebration never suppresses a route-change announcement
  }
  return { kind: 'celebration', text: action.text, tick: ((prev && prev.tick) || 0) + 1 };
}
